module.exports = __webpack_public_path__ + "media/images/photography/sub-nav-cm-538a7fbfa383b50e6fe828052882feaf.jpg";